
import { neighbourhoodsGeoJSON, boroughsGeoJSON } from "./utils";
import {
  majorMarketTileset,
  neighborhoodTileset,
  boroughTileset,
  _addZoningLayer,
  _addCommercialOverlayLayer,
  _addZoningAmendmentsLayer,
  _addRezoning2020,
  _addRezoning2015,
  _addRezoning2010,
  _addRezoningBefore2010,
  _addPendingRezoning,
  _addHistoricDistrinctLayer,
  _addFloodZoneLayer,
  _addSubwayLayer,
} from "../../../../shared/helpers/commonMapFilters";
import * as MapUtil from "../../../../shared/helpers/mapUtil";

export const mapScript = (searchTags, boundingBoxCoord) => `
mapboxgl.accessToken = 'pk.eyJ1IjoibmluZ3pob3UiLCJhIjoiY2lwaXBiaWtyMDFxZXVnbmpkaWR4dXd0MSJ9.GJX2c6TviB6opu84mCEOIg';
var map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/ningzhou/cjxxu65iq088b1cqgzu7sbxy2',
  center: [-73.9949712, 40.7379366],
  zoom: 10,
  attributionControl: false,
  logoPosition: 'bottom-right',
  scrollZoom: false,
  doubleClickZoom: false,
  dragPan: false,
  keyboard: false,
  touchZoomRotate: false,
});

function _addPolygonLayer(map, polygons) {
  polygons.forEach((coordinates, index) => {
    const sourceId = 'polygon-source-' + index;
    const layerId = 'polygon-layer-' + index;
    const outlineId = 'polygon-outline-' + index;

    map.addSource(sourceId, {
      type: 'geojson',
      data: {
        type: 'Feature',
        geometry: {
          type: 'Polygon',
          coordinates: coordinates.coordinates,
        },
      },
    });

    map.addLayer({
      id: layerId,
      type: 'fill',
      source: sourceId,
      layout: {},
      paint: {
        "fill-color": "#780F9E",
        "fill-opacity": 0.3,
      },
    });

    map.addLayer({
      id: outlineId,
      type: 'line',
      source: sourceId,
      layout: {},
      paint: {
        'line-color': '#780F9E',
        'line-width': 0.5,
      },
    });
  });
}

function _addSourceAndLayers(map, tileset) {
  map.addSource(tileset.id, {
    type: "vector",
    url: tileset.url,
  });
  map.addLayer({
    id: \`\${tileset.id}-layer-transparent\`,
    source: tileset.id,
    "source-layer": tileset.source_layer,
    type: "fill",
    paint: {
      "fill-outline-color": "#000",
      "fill-color": "#363347",
      "fill-opacity": 0,
    },
  });
  map.addLayer({
    id: \`\${tileset.id}-layer\`,
    source: tileset.id,
    "source-layer": tileset.source_layer,
    type: "fill",
    paint: {
      "fill-color": "#ccc",
      "fill-opacity": 0.1,
    },
    filter: [
      "in",
      \`\${tileset.id.includes("boroughs") ? "boro_name" : "name"}\`,
      "FALSE",
    ],
  });
  map.addLayer({
    id: \`\${tileset.id}-layer-highlighted\`,
    source: tileset.id,
    "source-layer": tileset.source_layer,
    type: "fill",
    paint: {
      "fill-color": "#BF96D9",
      "fill-opacity": 0.3,
    },
    filter: [
      "in",
      \`\${tileset.id.includes("boroughs") ? "boro_name" : "name"}\`,
      "FALSE",
    ],
  });

  const defaultLayerId = \`\${tileset.id}-layer-default\`;
  if (!map.getLayer(defaultLayerId)) {
    map.addLayer({
      id: defaultLayerId,
      source: tileset.id,
      "source-layer": tileset.source_layer,
      type: "fill",
      paint: {
        "fill-color": "#ccc",
        "fill-opacity": 0.1,
      },
    });
  }
  const outlineLayerId = \`\${tileset.id}-layer-outline\`;
  if (!map.getLayer(outlineLayerId)) {
    map.addLayer({
      id: outlineLayerId,
      source: tileset.id,
      "source-layer": tileset.source_layer,
      type: "line",
      paint: {
        "line-color": "#abb3d4",
        "line-width": 2,
      },
    });
  }
  const clickLayerId = \`\${tileset.id}-layer-click\`;
  if (!map.getLayer(clickLayerId)) {
    map.addLayer({
      id: clickLayerId,
      source: tileset.id,
      "source-layer": tileset.source_layer,
      type: "fill",
      paint: {
        "fill-color": "#780F9E",
        "fill-opacity": 0.4,
      },
      filter: ["==", "id", ""],
    });
  }
  window.searchTags = ${JSON.stringify(searchTags)};

 
  if (searchTags && searchTags.length > 0) {
    let neighborhoodIds = [];
    if (tileset.id.includes("boroughs")) {
      neighborhoodIds = searchTags.map((tag) =>{
        if(tag.id==="staten-island"){
          return "Staten Island"
        }
          else {
           return _capitalizeText(tag.id.replace(/^\w/, (c) => c.toUpperCase()))
          }
      }
       
      )
      map.setFilter(\`\${tileset.id}-layer-click\`, [
        "in",
        "boro_name",
        ...neighborhoodIds,
      ]);
    } else {
      neighborhoodIds = searchTags
        .map((tag) => (tag.id.includes("_ny") ? tag.id : \`\${tag.id}_ny\`))
        .map((tag) =>
          tag.includes("_major") ? tag.replace("_major", "") : tag
        );

      map.setFilter(\`\${tileset.id}-layer-click\`, [
        "in",
        "id",
        ...neighborhoodIds,
      ]);
    }
    console.log("Filtered Neighborhood IDs:", neighborhoodIds);
  }
  else{
  const tags=  [
      {
          "id": "Queens",
          "name": "queens",
          "type": "borough",
          "data": "queens"
      },
      {
          "id": "Manhattan",
          "name": "manhattan",
          "type": "borough",
          "data": "manhattan"
      },
      {
          "type": "borough",
          "data": "staten island",
          "id": "Staten Island",
          "name": "staten island"
      },
      {
          "type": "borough",
          "data": "bronx",
          "id": "Bronx",
          "name": "bronx"
      },
      {
          "type": "borough",
          "data": "brooklyn",
          "id": "Brooklyn",
          "name": "brooklyn"
      }
  ]

  if (tileset.id.includes("boroughs")) {
    neighborhoodIds = tags.map((tag) =>{  if(tag.id==="Staten Island"){
      return "Staten Island"
     }
     else{
     return tag.id.replace(/^\w/, (c) => c.toUpperCase())
     }});
    map.setFilter(\`\${tileset.id}-layer-click\`, [
      "in",
      "boro_name",
      ...neighborhoodIds,
    ]);
  } 
  
  }

}
function removeSourceAndLayers(map, sourceId) {
  // Get all layers from the map style
  const layers = map.getStyle().layers;

  // Remove all layers that use the source
  layers.forEach(layer => {
    if (map.getLayer(layer.id) && map.getLayer(layer.id).source === sourceId) {
      map.removeLayer(layer.id);
    }
  });

  // Now remove the source
  if (map.getSource(sourceId)) {
    map.removeSource(sourceId);
  }
}
function _addLocationNames(map, data) {
  map.addSource("location-names", {
    type: "geojson",
    data: data,
  });

  map.addLayer({
    id: "location-names",
    type: "symbol",
    source: "location-names",
    layout: {
      "text-field": ["get", "location"],
      "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
      "text-size": ["get", "fontSize"],
      "text-offset": ["get", "offset"],
    },
    paint: {
      "text-color": "#171F26",
    },
  });
}

function _capitalizeText(text) {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}
function calculatePolygonBounds(polygonData) {
  const bounds = new mapboxgl.LngLatBounds();
  polygonData.forEach(polygon => {
    polygon.coordinates[0].forEach(coord => {
      bounds.extend(coord);
    });
  });
  const mapBounds = [[bounds._sw.lng, bounds._sw.lat], [bounds._ne.lng, bounds._ne.lat]];
  
  return mapBounds;
}
function combineBoundingBoxes(box1, box2) {
  if (!box1 || box1.length === 0) return box2; // If box1 is empty, return box2
  if (!box2 || box2.length === 0) return box1; // If box2 is empty, return box1

  const minLng = Math.min(box1[0][0], box2[0][0]);
  const minLat = Math.min(box1[0][1], box2[0][1]);
  const maxLng = Math.max(box1[1][0], box2[1][0]);
  const maxLat = Math.max(box1[1][1], box2[1][1]);

  return [[minLng, minLat], [maxLng, maxLat]];
}

map.on('load', function() {
  const BOROUGHS = {
    Brooklyn: {
      center: [-73.949997, 40.650002],
    },
    Bronx: {
      center: [-73.865433, 40.837048],
    },
    Manhattan: {
      center: [-73.984016, 40.754932],
    },
    "Staten Island": {
      center: [-74.151535, 40.579021],
    },
    Queens: {
      center: [-73.769417, 40.742054],
    },
  };
  
  _addSourceAndLayers(map, ${JSON.stringify(boroughTileset)});
  _addSourceAndLayers(map, ${JSON.stringify(majorMarketTileset)});
  _addSourceAndLayers(map, ${JSON.stringify(neighborhoodTileset)});
  _addLocationNames(map, ${JSON.stringify(MapUtil._parseToGeoJSON([]))});
  const polygonCoordinates=searchTags.filter((item)=>item.id==="custom-area");
  
  window.boundingBoxCoord = ${JSON.stringify(boundingBoxCoord)};
  if(polygonCoordinates.length>0){
    _addPolygonLayer(map, polygonCoordinates[0].data);
  }       
  if(boundingBoxCoord.length>0 || (polygonCoordinates.length>0) ){
    const value=polygonCoordinates && polygonCoordinates[0] && polygonCoordinates[0].data? calculatePolygonBounds(polygonCoordinates[0].data): [];
    const combinedBounds = combineBoundingBoxes(boundingBoxCoord, value);
   
if(searchTags.length===1){
map.fitBounds(combinedBounds, {zoom:14});
} else{
map.fitBounds(combinedBounds);
}
    
    const locationSource = map.getSource("location-names");
    if (locationSource) {
      locationSource.setData(${JSON.stringify(
        MapUtil._parseToGeoJSON(
          neighbourhoodsGeoJSON.map((item) => ({
            ...item,
            fontSize: 16,
          }))
        )
      )});
    } else {
      console.error('Map source "location-names" not found.');
    }
  }
  else {
    //this block is for boroughs functionality

    
    const locationSource = map.getSource("location-names");
    if (locationSource) {
      locationSource.setData(${JSON.stringify(
        MapUtil._parseToGeoJSON(boroughsGeoJSON)
      )});
    } else {
      console.error('Map source "location-names" not found.');
    }
    removeSourceAndLayers(map, 'mp-neighborhoods');
    removeSourceAndLayers(map, "mp-major-markets");
  
    if(searchTags.length > 0 && boundingBoxCoord.length === 0){

      //position if no searchTags are selected contain boroughs

      map.flyTo({
        center:
          BOROUGHS[_capitalizeText(searchTags[0].name)].center,
         zoom: 10,
        essential: true,
      });
    }
    else{

     //center position default if no searchTags are selected
     
     map.flyTo({
        center: [-73.984016, 40.754932],
        zoom: 10,
        essential: true,
      });
    }
  }
  window.parent.postMessage({ type: 'MAP_LOADED' }, '*');
});
`;
